/**
 * Helps knowing what business representative section needs to function
 */
export class BusinessRepresentativeLabels {
  // prettier-ignore
  /**
   * @constructor
   */
  constructor( // NOSONAR
    public name: string,
    public lastName: string,
    public email: string,
    public password: string,
    public confirmPassword: string,
    public inform: string,
    public middleHeader: string,
    public agree: string,
    public termsAndConditions: string,
    public fileUpload: string[],
    public fileUploadAlt: string[]
  ) {}
}
